module.exports = __webpack_public_path__ + "img/1549483892.18a05f21.jpg";